import { render, staticRenderFns } from "./RemoveVisibility.vue?vue&type=template&id=36c509f2"
import script from "./RemoveVisibility.vue?vue&type=script&lang=js"
export * from "./RemoveVisibility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports